import $ from 'jquery'
import store_soins from "@/store/mods/clinique/soins"
import mod_prestation from "@/store/mods/clinique/prestations.js"
import TypeFacturationChoix from '@/components/type-facturation-choix'

export default {
    name: 'm-chirurgies',
    components: { TypeFacturationChoix },
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        refresh_state: Number,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object,
        format_ref_facture: String,
        selected_slug: String,
        patient_insurance_info: Object
    },
    data() {
        return {
            one_is_checked: [],
            save_loading: false,
            choice_is_empty: false,
            is_error: false,
            permission_is_denied: false,

            filter_chirurgie: '',
            filtered_chirurgies: [],
            selected_prestations: [],

            all_checked: false,
			each_cat_is_checked: [],
            text_grey: [],
            chrg_is_loading: true,
            chrg_is_empty: false,

            liste_chirurgies: [],

            // Type de facturation (normal / urgence), remis à normal à chaque ouverture (15/10/2026)
            type_facturation: 'normal'
        }
    },

    watch: {
        filter_chirurgie() {
            this.filterChirurgie()
        },

        one_is_checked() {
            this.choice_is_empty = false
        },

        type_facturation() {
            this.retirerSansPrix()
        },

        refresh_state() {
            if (this.selected_slug == 'chirurgie') {
                this.type_facturation = 'normal'
                this.$store.dispatch('getTypesFacturationPrestation')
                this.fetchChirurgie()
            }
        }
    },

    computed: {
        types_facturation_prestation() {
            return this.$store.getters['types_facturation_prestation']
        },
        
    },

    mounted() {
        
    },

    methods: {
        fetchChirurgie() {
            this.chrg_is_loading = true
            store_soins.getListeChirurgies().then((liste_chirurgies) => {
                this.liste_chirurgies = liste_chirurgies
                if (this.liste_chirurgies.length == 0) {
                    this.chrg_is_empty = true
                } else {
                    this.chrg_is_empty = false
                    this.filtered_chirurgies = this.liste_chirurgies
                }

                this.chrg_is_loading = false
            }).catch(() => {
                this.chrg_is_loading = false
                this.is_error = true
            })
        },

        hadleUndefinedPrice(libelle) {
            if (this.type_facturation === 'urgence') {
                this.warningToast("Tarif urgence non configuré pour " + (libelle || "cette chirurgie"))
                return
            }
            this.warningToast("Le prix de cette chirurgie n'a pas été défini !")
        },

        /**
         * Prix du K pour le type de facturation choisi (prix urgence NULL = non configuré).
         * Catalogue : pu / pu_urgence ; chirurgie cochée : prix / prix_urgence
         */
        prixSelonType(chirurgie) {
            let prix = 0
            if (this.type_facturation === 'urgence') {
                prix = ('pu_urgence' in chirurgie) ? chirurgie.pu_urgence : chirurgie.prix_urgence
            } else {
                prix = ('pu' in chirurgie) ? chirurgie.pu : chirurgie.prix
            }
            return Number(prix)
        },

        /**
         * Changement de type : décocher les chirurgies sans prix pour ce type
         */
        retirerSansPrix() {
            const sans_prix = this.one_is_checked.filter(chirurgie => !(this.prixSelonType(chirurgie) > 0))
            if (sans_prix.length == 0) {
                return
            }
            this.one_is_checked = this.one_is_checked.filter(chirurgie => this.prixSelonType(chirurgie) > 0)
            this.each_cat_is_checked = []

            const motif = (this.type_facturation === 'urgence') ? 'Tarif urgence non configuré' : 'Prix non configuré'
            this.warningToast(motif + " pour " + sans_prix.map(chirurgie => chirurgie.nom).join(', ') + " (décochée(s))")
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }
            console.log("BB: ",this.one_is_checked);
            

            this.one_is_checked = this.setPrestationUID(this.one_is_checked)

            console.log("AA ", this.one_is_checked);
            

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.one_is_checked.map(chirurgie => Object.assign({}, chirurgie, { type_facturation: this.type_facturation })),
                type_prestation: 'Chirurgie',
                data_type: 'chirurgie',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: this.formatSexeMetier(this.info_patient.sexe),
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
                format_ref_facture: this.format_ref_facture
            }

            this.save_loading = true
            mod_prestation.getTarifPrestation(data).then((response) => {
                // Urgence sans prix urgence configuré : jamais facturée, ni au prix normal
                const urgences_absentes = (response.prestations || []).filter(prestation => prestation.tarif_urgence_absent == 1)
                if (urgences_absentes.length > 0) {
                    this.save_loading = false
                    this.dangerToast("Tarif urgence non configuré pour " + urgences_absentes.map(prestation => prestation.libelle).join(', '))
                    return
                }

                data = Object.assign(data, response)
                data.duree_forfait_hospi_est_expire = this.patient_insurance_info.duree_forfait_hospi_est_expire
                this.$store.dispatch('saveVentePrestation', data).then((response) => {
                    if (response.success) {
                        this.successToast('Ajout effectué avec succès')

                        this.$emit('emitPrestation', response.fpro_id)

                        this.one_is_checked = []
                        this.$refs.fpro_chirurgie.click()

                        if (response.fpro_id > 0) {
                            this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                        }
                    } else {
                        this.$refs.fpro_chirurgie.click()
                        this.dangerToast(response.message)
                    }

                    this.save_loading = false
                }).catch((error) => {
                    this.save_loading = false
                    this.$refs.fpro_chirurgie.click()
                    // Refus de la caisse (ex. 422 : tarif urgence non configuré) : afficher son message
                    this.dangerToast((error && error.response && error.response.data && error.response.data.message) || 'Une erreur est survenue lors de l\'enregistrement. Veuillez réessayer plus tard.')
                })
            }).catch(() => {
                this.save_loading = false
                this.$refs.fpro_chirurgie.click()
                this.dangerToast('Une erreur est survenue lors du calcul des tarifs. Veuillez réessayer plus tard.')
            })
        },

        filterChirurgie() {
            this.filtered_chirurgies = [];

            if (this.filter_chirurgie == '') {
                this.filtered_chirurgies = this.liste_chirurgies
            } else {
                this.liste_chirurgies.forEach((categorie_chirurgie) => {
                    categorie_chirurgie.kchirurgies.forEach(chirurgie => {
                        let cleaned_chirurgie = this.removeAccents(chirurgie.k_chirurgie)
                        let cleaned_filter = this.removeAccents(this.filter_chirurgie)
    
                        if (cleaned_chirurgie.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                            this.filtered_chirurgies.push(chirurgie)
                        }
                    });
                });
                
            }
        },

        /**
		 * Sélectionner / Déselectionner une catégorie de médicament
		 */
		touteCategorie(index) {
			let is_checked = $('#kchirurgie-tous'+index).is(":checked")

            this.toggleCategorieChecked(is_checked, index)
		},

        toggleCategorieChecked(is_checked, index) {
            this.liste_chirurgies.forEach((categorie_chirurgie) => {
                if (categorie_chirurgie.chirurgie_id == index) {

                    let one_price_is_undefined = false

                    categorie_chirurgie.kchirurgies.forEach((_data) => {
                        this.text_grey[_data.id] = (is_checked)?'text-grey':''

                        console.log("PU: ", _data.k_chirurgie," : ",_data.pu);

                        // Prix du type de facturation choisi (pu ou pu_urgence)
                        if (!(this.prixSelonType(_data) > 0)) {
                            one_price_is_undefined = true
                        }
                        

                        const tmp_chirurgie = {
                            id: _data.id,
                            parent_libelle: categorie_chirurgie.chirurgie,
                            parent_id: categorie_chirurgie.chirurgie_id,
                            kid: _data.k_id,
                            nom: _data.k_chirurgie,
                            prix: _data.pu,
                            prix_urgence: _data.pu_urgence
                        }
                        if (is_checked) {
                            if (!(this.prixSelonType(_data) > 0)) {
                                one_price_is_undefined = true
                            } else {
                                this.one_is_checked.push(tmp_chirurgie)
                            }
                            
                        } else {
                            this.one_is_checked = this.one_is_checked.filter(item => item.id != tmp_chirurgie.id)
                        }
                    })

                    if (one_price_is_undefined) {
                        if (this.type_facturation === 'urgence') {
                            this.warningToast("Tarif urgence non configuré pour une ou plusieurs chirurgies (décochée(s) dans la liste) !")
                        } else {
                            this.warningToast("Le prix d'une ou plusieurs chirurgies (décochée(s) dans la liste) n'a pas été défini !")
                        }
                    }
                }
            });
            
            this.all_checked = is_checked
        },
    }
}
